module.exports = __webpack_public_path__ + "static/media/SamsumgMock.a69733da.png";